import produce from 'immer';
import margeById from '../../../helpers/margeById';

export const actions = {
  /**
   * Actions that fire saga watchers
   */

  // Plural
  GET_PENDING_ARTISAN_PRODUCTS: 'GET_PENDING_ARTISAN_PRODUCTS',

  // Singular
  UPDATE_PENDING_ARTISAN_PRODUCT: 'UPDATE_PENDING_ARTISAN_PRODUCT',

  GET_SINGLE_PENDING_ARTISAN_PRODUCT: 'GET_SINGLE_PENDING_ARTISAN_PRODUCT',

  DELETE_SINGLE_PENDING_ARTISAN_PRODUCT:
    'DELETE_SINGLE_PENDING_ARTISAN_PRODUCT',
   MODERATE_CREATE_SINGLE_PENDING_ARITSAN_PRODUCT: 'MODERATE_CREATE_SINGLE_PENDING_ARITSAN_PRODUCT',  
    
    /**
     * Actions that are fired by redux-saga watchers
     */
    
    // Plural
    GET_PENDING_ARTISAN_PRODUCTS_SUCCESS: 'GET_PENDING_ARTISAN_PRODUCTS_SUCCESS',
    
    // Singular
    UPDATE_PENDING_ARTISAN_PRODUCT_SUCCESS:
    'UPDATE_PENDING_ARTISAN_PRODUCT_SUCCESS',
    GET_SINGLE_PENDING_ARTISAN_PRODUCT_SUCCESS:
    'GET_SINGLE_PENDING_ARTISAN_PRODUCT_SUCCESS',
    DELETE_SINGLE_PENDING_ARTISAN_PRODUCT_SUCCESS:
    'DELETE_SINGLE_PENDING_ARTISAN_PRODUCT_SUCCESS',
    MODERATE_CREATE_SINGLE_PENDING_ARITSAN_PRODUCT_SUCCESS: 'MODERATE_CREATE_SINGLE_PENDING_ARITSAN_PRODUCT_SUCCESS', 
    /**
   * Misc
   */
  SET_PENDING_ARTISAN_PRODUCTS_IS_LOADING:
    'SET_PENDING_ARTISAN_PRODUCTS_IS_LOADING',
  SET_PENDING_ARTISAN_PRODUCTS_COUNT: 'SET_PENDING_ARTISAN_PRODUCTS_COUNT',
};

const initalState = {
  items: [],
  isLoading: false,
  count: 0,
};

export default produce((draft, action) => {
  const { type, payload } = action;

  if (!draft) return initalState;

  switch (type) {
    case actions.GET_PENDING_ARTISAN_PRODUCTS_SUCCESS: {
      const currentProducts = draft.items;
      const products = payload;
      draft.items = margeById(currentProducts, products);
      break;
    }

    case actions.UPDATE_PENDING_ARTISAN_PRODUCT_SUCCESS: {
      const currentItems = draft.items;
      const updatedItems = currentItems.filter((item) => payload !== item._id);
      draft.items = updatedItems;
      break;
    }
    case actions.GET_SINGLE_PENDING_ARTISAN_PRODUCT_SUCCESS: {
      const currentProducts = draft.items;
      console.log(currentProducts);
      draft.items = margeById(currentProducts, [payload]);
      break;
    }

    case actions.SET_PENDING_ARTISAN_PRODUCTS_COUNT: {
      draft.count = payload;
      break;
    }

    case actions.SET_PENDING_ARTISAN_PRODUCTS_IS_LOADING: {
      draft.isLoading = payload;
      break;
    }
     case actions.DELETE_SINGLE_PENDING_ARTISAN_PRODUCT_SUCCESS: {
      draft.items = draft.items.filter((item) => item._id !== payload);
      break;
    }
    case actions.MODERATE_CREATE_SINGLE_PENDING_ARITSAN_PRODUCT_SUCCESS: {
      draft.items = draft.items.filter((item) => item._id !== payload.id)
      break;
    }
  }
});
